import React from "react";
import { useUiLang } from "utils/uiLanguage";

/**
 * Красная полоса над дорожками: отказ сервера словами — и выход из отказа автосохранения.
 *
 * Непринятая правка остаётся несохранённой, а каждая операция (♪, «+», склейка, разбивка,
 * удаление, выключатель режима) сначала сохраняет несохранённое — и падала на ней, пока
 * перезагрузка не теряла правку молча. «Сбросить несохранённое» убирает непринятые правки
 * (провайдер сперва спрашивает и показывает, что будет потеряно) и снимает запор.
 */
export const EditorErrorBanner = ({
    message,
    refusedEdits,
    onClose,
    onDiscard,
}: {
    message: string | null;
    refusedEdits: number;
    onClose: () => void;
    onDiscard: () => void;
}) => {
    const en = useUiLang() === "en";
    if (!message) return null;
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 8,
                padding: "6px 12px",
                backgroundColor: "#fff2f0",
                border: "1px solid #ffccc7",
                color: "#cf1322",
                fontSize: 13,
            }}
        >
            <span>{message}</span>
            <span style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
                {refusedEdits > 0 && (
                    <span
                        data-discard-unsaved="true"
                        role="button"
                        title={
                            en
                                ? "Drop the edits the server refused (you will see them first); the rest is saved and the folder is re-read"
                                : "Убрать правки, которые сервер не принял (сначала покажу, какие); остальное сохранится, папка перечитается"
                        }
                        style={{ cursor: "pointer", fontWeight: 600, textDecoration: "underline" }}
                        onClick={onDiscard}
                    >
                        {en ? "Discard unsaved" : "Сбросить несохранённое"}
                    </span>
                )}
                <span
                    data-close-error="true"
                    style={{ cursor: "pointer", fontWeight: 600, padding: "0 4px" }}
                    onClick={onClose}
                >
                    ✕
                </span>
            </span>
        </div>
    );
};
